import {WBIcon} from '@wandb/ui';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Button as SemanticButton,
  Modal as SemanticModal,
} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-height: 2000px;
  overflow: auto;
  padding: 32px 64px;
  background: ${globals.WHITE};
  border: 1px solid ${globals.MOON_200};
  border-radius: 8px;
  margin-bottom: 40px;
`;

export const EditIcon = styled(WBIcon).attrs({name: `edit`})`
  font-size: calc(${globals.fontSizeStandard} * 1.5);
`;

export const Modal = styled(SemanticModal)`
  @media (min-width: 1200px) {
    min-width: 1200px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 24px;
  box-shadow: ${globals.boxShadowSection};
  gap: 16px;
`;

export const ModalSaveButton = styled(SemanticButton)`
  &&& {
    width: 160px;
    margin-right: 48px;
  }
`;

export const ModalCloseIcon = styled(WBIcon)`
  font-size: 40px;
  cursor: pointer;
  color: ${globals.gray500};
`;

export const ModalWarningOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.9);
  padding-top: 160px;
  display: flex;
  justify-content: center;
`;

export const ModalWarningContent = styled.div``;

export const ModalWarningText = styled.div`
  font-size: 24px;
  font-weight: 600;
`;

export const ModalWarningActions = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const ModalWarningButton = styled(SemanticButton)`
  &&& {
    width: 160px;

    &:not(:first-child) {
      margin-left: 48px;
    }
  }
`;
